class Filter {

  constructor() {

    this.$allActus = document.querySelectorAll('.cards .card');
    this.$filtersWrapper = document.querySelector('.filters');

    // data-* key name
    this.cat = 'cat';
    this.addEventListener();
  }

  addEventListener() {
    document.body.addEventListener('click', e => {
      this.handleFilterClick(e);
    })
  }


  handleFilterClick(e) {

    const isFilterWrapperClicked = this.$filtersWrapper.contains(e.target);
    if (isFilterWrapperClicked) {
      this.resetChanges();
      this.filterActus(e);
    }
  }

  addClass(selector, className) {
    selector.classList.add(`${className}`);
  }

  removeClass(selector, className) {
    selector.forEach(item => item.classList.contains(`${className}`) && item.classList.remove(`${className}`));
  }

  filterActus(e) {
    this.addClass(e.target, 'active');
    e.target.classList.add('active');
    this.$allActus.forEach(actu => {
      if (e.target.getAttribute(`data-${this.cat}`)) this.subFilter(e.target, actu, this.cat);
    })
  }

  subFilter(target, item, dataKey) {
    if (item.getAttribute(`data-${dataKey}`) != target.getAttribute(`data-${dataKey}`)) {
      item.style.display = 'none';
    }
  }


  resetChanges() {
    this.removeClass(this.$filtersWrapper.querySelectorAll('button'), 'active');
    this.$allActus.forEach(actu => {
      if (actu.style.display === 'none') actu.style.display = 'block';
    })
  }

}

const filters = document.querySelector('.filters');
if (filters) new Filter();


// WEBPACK FOOTER //
// ./scripts/modules/filter.js